<div class="container pt-3 fade-in-left" id="centerFrame">
  <div class="d-flex align-items-center justify-content-center mb-4 pe-1">
    <div class="flex-grow-0">
      <a [routerLink]="['/comercio']">
        <div class="p-2"><i class="bi bi-chevron-left align-middle"></i></div>
      </a>
    </div>

    <div class="p-2 flex-grow-1 ps-2 pe-5 overflow-hidden">
      <h1 class="text-dark text-center text-truncate">Compra en {{ x_nombre_fantasia_comercio }}</h1>
    </div>

    <div class="p-2 pl-2 help" (click)="openhelp()"><i class="bi bi-info-circle"></i></div>
  </div>

  <!-- Tooltip ayuda -->
  <div class="row m-3 p-3 align-items-center" id="tooltip-pwa" [class.is-open]="helpOpen">
    <div class="col-auto"><i class="bi bi-info-circle" style="font-size: 1.8em;"></i></div>
    <div class="col" id="helpinfo">
      Podrás seleccionar medicamentos en la búsqueda superior o productos destacados del local.
    </div>
    <div class="col-auto" (click)="openhelp()"><i class="bi bi-x-lg" style="font-size: 1.4em;"></i></div>
  </div>

  <!-- ========================= -->
  <!-- CONTENIDO PRINCIPAL -->
  <!-- ========================= -->
  <div [class.d-none]="cartOpen">
    <!-- Medicamentos -->
    @if (b_vende_medicamentos) {
      <div class="row-cols-12 m-2 mt-0" id="products-sell-one">
        <div class="row-cols-12 mt-0">
          <div class="text-p p-3 pt-2 pb-2" style="font-weight: bold; font-size: 1em;">
            Agregá tu Medicamento
          </div>
        </div>
      </div>

      <div id="products-sell-two">
        <div class="row-cols-12 p-3 pt-0 pb-0 ps-4 pe-4 input-group fade-in search-input-row">
          <div class="col-auto rounded-start" id="search-addon">
            <div class="mx-auto d-block p-1 d-inline-flex pt-1 ps-2"><i class="bi bi-search"></i></div>
          </div>

          <div class="col rounded">
            <input
              type="search"
              class="form-control search-input shadow-none"
              placeholder="Busca tu medicamento aquí"
              aria-label="Search"
              aria-describedby="search-addon"
              (keyup)="onSearchInput($any($event.target).value)"
              id="busqueda"
            />
          </div>

          <div class="col-auto rounded-end text-end" id="mic-addon">
            <div class="mx-auto d-block p-1 d-inline-flex"><i class="bi bi-mic"></i></div>
          </div>
        </div>

        <div class="row-cols-12 m-2 ps-2 pe-2 w-100" id="products-sell-three" [class.no-products]="b_vende_medicamentos && productos.length === 0">
          <div class="resultSearch">
            <!-- Encabezado resultados -->
            <div class="title-container p-3 pb-0" [class.d-none]="!isSearching">
              <div class="title-line"></div>

              @if (((vademecumsFiltrados$ | async)?.length ?? 0) !== 0 && searchUiState !== 'minChars') {
                <span class="title">
                  Resultados ({{ (vademecumsFiltrados$ | async)?.length }})
                </span>
              }

              @if (searchUiState === 'minChars') {
                <span class="title no-results">
                  Debe ingresar más de {{ minimaCantidadCaracteres }} caracteres para iniciar la búsqueda.
                </span>
              }

              @if (searchUiState !== 'minChars' && ((vademecumsFiltrados$ | async)?.length ?? 0) === 0 && isSearching) {
                <span class="title no-results">
                  No se han encontrado resultados para su búsqueda. Intente nuevamente.
                </span>
              }

              <div class="title-line"></div>
            </div>

            <!-- Lista resultados -->
            @for (vademecum of (vademecumsFiltrados$ | async) ?? []; track vademecum.id) {
              <a class="hiddenList">
                <div class="row p-3 pb-0 align-items-top">
                  <div class="row">
                    <div class="col">
                      <div class="col row">
                        <div class="col-12 text-title-item pe-0">{{ vademecum.x_nombre }}</div>

                        <div class="row col">
                          @if (n_porcentaje_descuento_medicamentos === 0) {
                            <div class="col-auto text-title-item pe-0 text-success">
                              <b>{{ vademecum.n_precio | currency:'ARS' }}</b>
                            </div>
                          } @else {
                            <div class="row">
                              <div class="col-auto text-title-item pe-0 text-successs text-decoration-line-through text-center">
                                <b>{{ vademecum.n_precio | currency:'ARS' }}</b>
                              </div>
                              <div class="col-auto text-title-item pe-0 text-primarys">
                                <b>{{ ((vademecum.n_precio! * (1 - n_porcentaje_descuento_medicamentos / 100)) || 0) | currency:'ARS' }}</b>
                              </div>
                            </div>
                          }
                        </div>
                      </div>

                      <div class="col-12 text-detail-item">
                        {{ vademecum.nombreLaboratorio }} - {{ vademecum.x_presentacion }}
                      </div>

                      @if (vademecum.nombreDrogas) {
                        <div class="col-12 text-detail-item text-muted">
                          <i class="bi bi-capsule"></i> {{ vademecum.nombreDrogas }}
                        </div>
                      }
                    </div>

                    <div class="col-auto">
                      <div class="add-button mt-2 me-2" (click)="addVademecumCart(vademecum)">
                        <i class="bi bi-plus align-middle"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </a>
            }

            <!-- Fin de resultados -->
            @if (isSearching && searchUiState !== 'minChars' && (((vademecumsFiltrados$ | async)?.length ?? 0) !== 0)) {
              <div class="title-container p-3 pb-0">
                <div class="title-line"></div>
                <span class="title">Fin de Resultados</span>
                <div class="title-line"></div>
              </div>
            }

            <!-- Aclaración cuando no hay seleccionados -->
            <div
              class="text-p p-0 ps-3 pe-3 pt-2 pb-2 text-center"
              style="font-size: 0.8em; color: #878787;"
              id="aclaracion"
              [class.d-none]="vademecumsSeleccionados.length != 0"
            >
              {{ vademecumsSeleccionados.length == 0 ? "Elegí todos los medicamentos que quieras agregar a tu carrito de compras." : "" }}
              <br /><br />
              {{ vademecumsSeleccionados.length == 0 ? "Los precios son sugeridos." : "" }}
            </div>
          </div>
        </div>
      </div>

      <hr class="divisor mt-4 mb-4" id="products-sell-four" />
    }

    <!-- Productos -->
    @if (!b_vende_medicamentos || productos.length > 0) {
      <div class="row-cols-12 m-2" id="products-sell-five">
        <div class="row-cols-12">
          <div class="text-p p-3 pb-1" style="font-weight: bold; font-size: 1em;">
            Agregá a tu pedido
          </div>
        </div>
      </div>

       @if (productos.length > 0) {
        <div class="row fade-in pt-2 pb-5 m-2 mb-5" id="products-sell-six">
          @for (producto of productos; track producto.id) {
            <div class="col-sm-4 col-6 col-lg-2 pt-2 pb-2">
              <div class="item" [class.active]="isActiveProducto(producto.id!)">
                <div class="row ms-0 me-0 ps-2 pe-2 d-flex align-items-center">
                  <div class="col-4 ps-0 pe-0 align-items-center">
                    @if (producto.n_porcentaje_descuento != null && producto.n_porcentaje_descuento != 0) {
                      <div class="rounded bg-primarys text-light discount-shop d-flex align-items-center mt-1">
                        -{{ producto.n_porcentaje_descuento }}%
                      </div>
                    }
                  </div>

                  <div class="col-8 ps-0 pe-0 align-items-center">
                    <div class="add-button mt-2 me-0" (click)="addProductoCart(producto)">
                      <i class="bi bi-plus align-middle"></i>
                    </div>

                    <div class="quantity-button quantity mt-2 me-1 d-flex align-items-center">
                      {{ qtyProducto(producto.id!) }}
                    </div>

                    <div class="remove-button remove mt-2 me-1" (click)="removeProductoCart(producto)">
                      <i [ngClass]="{'bi bi-dash': qtyProducto(producto.id!) != ''}" class="align-middle"></i>
                    </div>
                  </div>
                </div>

                <div class="text-center ms-3 me-3 mt-4">
                  <img
                    [src]="producto.x_img_producto ? API_URI + 'uploads/images/'+ producto.x_img_producto : './assets/img/no-image.png'"
                    class="item-shop-img"
                  />
                </div>

                @if (producto.n_porcentaje_descuento && producto.n_porcentaje_descuento > 0) {
                  <div class="col-auto text-title-item pe-0 text-danger text-decoration-line-through text-center">
                    <b>{{ producto.n_precio | currency:'ARS' }}</b>
                  </div>
                }

                <div
                  class="col-auto text-title-item pe-0 text-center"
                  [ngClass]="(producto.n_porcentaje_descuento && producto.n_porcentaje_descuento > 0) ? 'text-primarys' : 'text-successs'"
                >
                  <b>
                    {{
                      (producto.n_porcentaje_descuento && producto.n_porcentaje_descuento > 0)
                        ? ((producto.n_precio! * (1-producto.n_porcentaje_descuento/100)) | currency:'ARS')
                        : (producto.n_precio | currency:'ARS')
                    }}
                  </b>
                </div>

                <div class="item-shop-desc p-2">{{ producto.x_nombre }}</div>
              </div>
            </div>
          }
        </div>
      } @else {
        <div class="text-center text-muted p-4">
          Este comercio no tiene productos activos cargados.
        </div>
      }
    }

    <div class="alert alert-danger mt-2" role="alert" [class.d-none]="error.length == 0">
      <small>{{ error }}</small>
    </div>
  </div>

  <!-- ========================= -->
  <!-- CARRITO -->
  <!-- ========================= -->
  <div id="cart" class="row fade-in pt-2 pb-2 m-2" [class.is-open]="cartOpen">
    <div class="row align-items-center pe-0">
      <div class="col-10 col-lg-11 text-p p-3 pb-1" style="font-weight: bold; font-size: 1em;">
        Tu Carrito
      </div>
      <div
        class="col-2 col-lg-1 text-p p-3 pb-1 text-end close-modal-btn pe-0"
        style="font-weight: bold; font-size: 1em;"
        (click)="openmodal()"
      >
        <i class="bi bi-x-circle"></i>
      </div>
    </div>

    <hr />

    <div class="col align-items-center pb-5 mb-5">
      <!-- Vademécums en carrito -->
      @for (vademecumSel of vademecumsSeleccionados; track vademecumSel.id_vademecum) {
        <a class="hiddenList">
          <div class="row p-3 mb-2 align-items-top" [class.active]="isActiveVademecum(vademecumSel.id_vademecum!)">
            <div class="col-8">
              <div class="col-12 text-title-item pe-0">{{ vademecumSel.x_nombre }}</div>
              <div class="col-12 text-detail-item">
                {{ vademecumSel.nombreLaboratorio }} - {{ vademecumSel.x_presentacion }}
              </div>
            </div>

            <div class="col-4 pe-0">
              <div class="col-12 text-end">
                @if (n_porcentaje_descuento_medicamentos === 0) {
                  <div class="col-auto text-title-item pe-0 text-success">
                    <b>{{ vademecumSel.n_precio | currency:'ARS' }}</b>
                  </div>
                } @else {
                  <div class="col-auto text-title-item pe-0 text-successs text-decoration-line-through text-end">
                    <b>{{ vademecumSel.n_precio | currency:'ARS' }}</b>
                  </div>
                  <div class="col-auto text-title-item pe-0 text-primarys">
                    <b>{{ ((vademecumSel.n_precio! * (1 - n_porcentaje_descuento_medicamentos / 100)) || 0) | currency:'ARS' }}</b>
                  </div>
                }
              </div>

              <div class="col-12 text-end">
                <div class="add-button mt-2" (click)="addQtyVademecumCart(vademecumSel)">
                  <i class="bi bi-plus align-middle"></i>
                </div>
                <div class="quantity-button quantity mt-2 me-2 d-flex align-items-center">
                  {{ vademecumSel.n_cantidad }}
                </div>
                <div class="remove-button remove mt-2 me-2" (click)="removeVademecumCart(vademecumSel)">
                  <i class="bi bi-dash align-middle"></i>
                </div>
              </div>
            </div>
          </div>
        </a>
      }

      <!-- Productos en carrito -->
      @for (productosSel of productosSeleccionados; track productosSel.id_producto) {
        <a class="hiddenList">
          <div class="row p-3 mb-2 align-items-top" [class.active]="isActiveProducto(productosSel.id_producto!)">
            <div class="col-8">
              <div class="col-12 text-title-item pe-0">{{ productosSel.x_nombre }}</div>
              <div class="col-12 text-detail-item">SKU: {{ productosSel.x_sku }}</div>
            </div>

            <div class="col-4 pe-0">
              @if (!productosSel.n_porcentaje_descuento || productosSel.n_porcentaje_descuento <= 0) {
                <div class="col-12 text-end">
                  <div class="col-12 text-title-item pe-0 text-success">
                    <b>{{ productosSel.n_precio | currency:'ARS' }}</b>
                  </div>
                </div>
              } @else {
                <div class="col-12 text-end">
                  <div class="col-12 text-title-item pe-0 text-primarys">
                    <b>{{ (productosSel.n_precio! * (1-productosSel.n_porcentaje_descuento/100)) | currency:'ARS' }}</b>
                  </div>
                </div>

                <div class="col-12 text-end">
                  <div class="col-12 pe-0 d-flex flex-row-reverse">
                    <div class="text-title-item bg-primary text-light discount-shop-cart d-flex align-items-center w-auto pe-1 ps-1">
                      {{ productosSel.n_porcentaje_descuento }}% OFF
                    </div>
                  </div>
                </div>

                <div class="col-12 text-end">
                  <div class="col-12 text-detail-item pe-0 text-danger text-decoration-line-through">
                    {{ productosSel.n_precio | currency:'ARS' }}
                  </div>
                </div>
              }

              <div class="col-12 text-end">
                <div class="add-button mt-2" (click)="addQtyProductoCart(productosSel)">
                  <i class="bi bi-plus align-middle"></i>
                </div>
                <div class="quantity-button quantity mt-2 me-2 d-flex align-items-center">
                  {{ productosSel.n_cantidad }}
                </div>
                <div class="remove-button remove mt-2 me-2" (click)="removeProductoOrdenComercioCart(productosSel)">
                  <i class="bi bi-dash align-middle"></i>
                </div>
              </div>
            </div>
          </div>
        </a>
      }
    </div>
  </div>

  <!-- Botones flotantes -->
  <div
    class="floating-button floating-button-right fade-in"
    [hidden]="vademecumsSeleccionados.length == 0 && productosSeleccionados.length == 0"
  >
    <button type="submit" class="btn btn-primary btn-lg mt-0" [disabled]="loading" (click)="savePedido()">
      {{ loading ? 'Cargando...' : 'Continuar' }}
    </button>
  </div>

  <div
    class="floating-button bag fade-in"
    [hidden]="vademecumsSeleccionados.length == 0 && productosSeleccionados.length == 0"
    (click)="openmodal()"
  >
    <div class="flex-grow-1 d-flex justify-content-center">
      <div class="p-2"><i class="bi bi-bag align-middle"></i></div>
    </div>
  </div>

  <div
    class="floating-button floating-counter-button fade-in"
    [hidden]="vademecumsSeleccionados.length == 0 && productosSeleccionados.length == 0"
  >
    {{ n_cantidad_elementos }}
  </div>
</div>
